import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Hospedagem from "../pages/hospedagem/page";
import Vps from "../pages/vps/page";
import Servidores from "../pages/servidores/page";
import Revenda from "../pages/revenda/page";
import Dominios from "../pages/dominios/page";
import Sites from "../pages/sites/page";
import Solucoes from "../pages/solucoes/page";
import LojasVirtuais from "../pages/lojas-virtuais/page";
import Sistemas from "../pages/sistemas/page";
import Sobre from "../pages/sobre/page";
import Contato from "../pages/contato/page";
import Suporte from "../pages/suporte/page";
import AreaDoCliente from "../pages/area-do-cliente/page";
import Blog from "../pages/blog/page";
import BlogEntry from "../pages/blog/entry";
import BlogSearch from "../pages/blog/search";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hospedagem",
    element: <Hospedagem />,
  },
  {
    path: "/vps",
    element: <Vps />,
  },
  {
    path: "/servidores",
    element: <Servidores />,
  },
  {
    path: "/revenda",
    element: <Revenda />,
  },
  {
    path: "/dominios",
    element: <Dominios />,
  },
  {
    path: "/sites",
    element: <Sites />,
  },
  {
    path: "/solucoes",
    element: <Solucoes />,
  },
  {
    path: "/lojas-virtuais",
    element: <LojasVirtuais />,
  },
  {
    path: "/sistemas",
    element: <Sistemas />,
  },
  {
    path: "/sobre",
    element: <Sobre />,
  },
  {
    path: "/contato",
    element: <Contato />,
  },
  {
    path: "/suporte",
    element: <Suporte />,
  },
  {
    path: "/area-do-cliente",
    element: <AreaDoCliente />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/blog/busca",
    element: <BlogSearch />,
  },
  {
    path: "/blog/:slug",
    element: <BlogEntry />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;